<template>
  <div class="c-app flex-row align-items-center" :class="{ 'c-dark-theme': $store.state.darkMode }">
    <CContainer>
      <CRow class="justify-content-center">
        <CCol md="8">
          <CCardGroup>
            <CCard class="p-4">
              <CCardBody>
                <CForm>
                  <h1>Login</h1>
                  <p class="text-muted">Inicia sesión con tu cuenta</p>
                  <CInput
                    :value.sync="data.username"
                    :disabled="loading"
                    placeholder="Username"
                    autocomplete="username email"
                  >
                    <template #prepend-content><CIcon name="cil-user"/></template>
                  </CInput>
                  <CInput
                    :value.sync="data.password"
                    :disabled="loading"
                    placeholder="Password"
                    type="password"
                    autocomplete="curent-password"
                  >
                    <template #prepend-content><CIcon name="cil-lock-locked"/></template>
                  </CInput>
                  <CRow>
                    <CCol col="6" class="text-left">
                      <template v-if="loading">
                        <CCardBody>
                          <div class="sk-chase">
                            <div class="sk-chase-dot"></div>
                            <div class="sk-chase-dot"></div>
                            <div class="sk-chase-dot"></div>
                            <div class="sk-chase-dot"></div>
                            <div class="sk-chase-dot"></div>
                            <div class="sk-chase-dot"></div>
                          </div>
                        </CCardBody>
                      </template>
                      <template v-else>
                        <CButton color="primary" class="px-4" @click="signIn()">Login</CButton>
                      </template>
                    </CCol>
                    <!-- <CCol col="6" class="text-right">
                      <CButton color="link" class="px-0">Forgot password?</CButton>
                      <CButton color="link" class="d-lg-none">Register now!</CButton>
                    </CCol> -->
                  </CRow>
                </CForm>
              </CCardBody>
            </CCard>
            <CCard
              color="primary"
              text-color="white"
              class="text-center py-5 d-md-down-none"
              body-wrapper
            >
              <CCardBody>
                <h2>Nutrivan</h2>
                <p>Bienvenido al sistema.</p>
              </CCardBody>
            </CCard>
          </CCardGroup>
        </CCol>
      </CRow>
    </CContainer>
  </div>
</template>

<script>

  import Swal from "sweetalert2"
  import {signIn} from '../../assets/js/methods/functions.js'

  export default {
    name: 'Login',
    data () {
      return {
        prefix: "login",
        data: {
          username: "",
          password: "",
        },
        loading: false,
      }
    },
    methods: {
      async signIn(){
        
        this.loading = true;
        
        try {
        
          const url = this.$store.state.url;
          const response = await signIn(url + this.prefix, this.data);
                              
          if (response.status === 200) {
                        
            let data = response?.data;

            if(data.flag){
              
              sessionStorage.setItem('id', data.data?.id);
              sessionStorage.setItem('username', data.data?.username);
              sessionStorage.setItem('name', data.data?.name);
              sessionStorage.setItem('email', data.data?.email);
              sessionStorage.setItem('role_id', data.data?.role_id);
              sessionStorage.setItem('slug_role', data.data?.role?.slug);
              sessionStorage.setItem('role', data.data?.role?.name);
              sessionStorage.setItem('phone', data.data?.phone);

              this.$router.push({ 
                name: 'Perfil', 
              });

            } else {
              
              Swal.fire("Alerta", data.message, "warning");

            }

          }

        } catch (errors) {
          
          if (errors.length > 0) {
            Swal.fire("Alerta", errors[0], "warning");
          } else {
            Swal.fire("Alerta", "Ocurrió un error desconocido", "error");
          }

        } finally {

          this.loading = false;
        
        }

      },
    }
  }

</script>

<style src="spinkit/spinkit.min.css"></style>
